import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=0260e31e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0260e31e"]])

export default __exports__